import { defineStore } from "pinia"
export const useNotificationStore = defineStore('notification', {
    state: () => ({
        'body': window.$notification?.body,
        'heading': window.$notification?.heading,
        'type': window.$notification?.type,
        'level': window.$notification?.level,
    }),
    actions: {
        set(payload) {
            this.body = payload.body
            this.heading = payload.heading
            this.type = payload.type
            this.level = payload.level
        },
        clear() {
            this.set({})
        },
    }
  })
